import Marquee from "react-fast-marquee";

const words = [
  "Détente absolue",
  "Expertise",
  "Lâcher-prise",
  "Silhouette",
  "Sérénité",
  "Rituel",
  "Légèreté",
];

export default function EditorialMarquee({ speed = 28, reverse = false }) {
  return (
    <div
      className="relative py-8 md:py-12 border-y border-olive/10 bg-cream overflow-hidden"
      data-testid="editorial-marquee"
    >
      <Marquee
        speed={speed}
        direction={reverse ? "right" : "left"}
        gradient={false}
        pauseOnHover={false}
      >
        {words.concat(words).map((w, i) => (
          <span
            key={i}
            className="marquee-serif-italic text-[6vw] md:text-[4.5vw] leading-none px-6 font-light"
          >
            {w}
            <span className="text-olive/30 mx-4">·</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
